export function fixedScroll($action) {

    if ($action == 'enable') {

        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        // if any scroll is attempted, set this to the previous value
        window.onscroll = function () {
            window.scrollTo(scrollLeft, scrollTop);
        };

        $('body, html').css({
            overflowY: 'hidden',
        });

    } else if ($action == 'disable') {
        window.onscroll = function () {
        };
        $('body, html').removeAttr("style");
    }
}
